import React, { useContext } from 'react';
import classNames from 'classnames';
import useCreateSelectOptions from 'hooks/useCreateSelectOptions';
import { NOTIFICATION_BY } from 'models/Notification';
import { Button } from 'ncoded-component-library';
import NotificationsContext from 'providers/Notifications/Notifications.context';

import './NotificationForMyselfOrLeadsSelect.styles.scss';

type NotificationForMyselfOrLeadsSelectProps = {
  className?: string;
};

const NotificationForMyselfOrLeadsSelect: React.FC<
  NotificationForMyselfOrLeadsSelectProps
> = (props) => {
  const { className } = props;

  const { notificationBy, setNotificationBy } =
    useContext(NotificationsContext);

  const options = useCreateSelectOptions()(Object.values(NOTIFICATION_BY));

  const classes = classNames(
    'notification-for-myself-or-leads-select',
    className,
  );

  return (
    <div className={classes}>
      {options.map(({ value, label }) => (
        <Button
          key={label}
          variant="outline"
          className={classNames({ selected: notificationBy === value })}
          onClick={() => setNotificationBy(value)}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};

export default NotificationForMyselfOrLeadsSelect;
